export default "__VITE_ASSET__bQXuYzdc__"